
defsPackEditor.title.placeholder=Digite o título (tema ou algo assim)
defsPackEditor.description.placeholder=Insira a descrição
defsPackEditor.title.create=Criar novos flashcards
defsPackEditor.title.save=Editar flashcards
defsPackEditor.addPackImage=Adicionar imagem
visibility.label=Visível para
visibility.0=Apenas eu
visibility.1=Todos (após verificação)
visibility.2=Verificação
visibilityBadge.0=Privado
visibilityBadge.1=Público
visibilityBadge.2=Verificação
## не удаляйте этот блок, на него есть ссылки в {plurals}
pl.card.one=cartão
pl.card.few=cartas
pl.card.other=cartas
pl.day.one=dia
pl.day.few=dias
pl.day.other=dias
pl.passedReview.one=passou na revisão
pl.passedReview.few=avaliações aprovadas
pl.passedReview.other=avaliações aprovadas
pl.failedReview.one=revisão falhada
pl.failedReview.few=avaliações reprovadas
pl.failedReview.other=avaliações reprovadas
pl.freshCard.one=cartão novo
pl.freshCard.few=cartas novas
pl.freshCard.other=cartas novas
pl.hours.one=hora
pl.hours.few=horas
pl.hours.other=horas
pl.hours={0} {0,plural,one{hora}few{horas}other{horas}}
pl.days.one=dia
pl.days.few=dias
pl.days.other=dias
pl.days={0} {0,plural,one{dia}few{dias}other{dias}}
pl.minutes.one=minuto
pl.minutes.few=minutos
pl.minutes.other=minutos
pl.minutes={0} {0,plural,one{minuto}few{minutos}other{minutos}}
## validation
rubd.flashcards.services.validation.SideTextWhenCardIsNotEmpty.message=O cartão não está vazio, você precisa de algum texto para este lado
##
button.save=Salve
button.saveContinue=Salvar e continuar
button.create=Criar
button.cancel=Cancelar
button.clone=Clone
button.print=Imprimir
button.checkTest=Verifique os resultados
button.yes=Sim
button.close=Fechar
button.ok=OK
button.help=Ajuda
##
title.label=Título
title.description=Descrição
title.optional=(opcional)
## duration messages
fl.agoString={0} atrás
fl.agoRecently=Recentemente
fl.timeSpent={0} gasto
fl.timeSpentLessThanMinute=Passei um tempinho
##
pack.cardCount={0} cartas
pack.cardCount.one={0} cartão
pack.cardCount.many={0} cartas
pack.cardCount.few={0} cartas
##
page.defaultTitle=FlashCards on-line
## user private dashboard
fl.mainDashboard.packAgo.title=Tempo decorrido desde a última visita
fl.mainDashboard.packSpent.title=Tempo gasto aprendendo
fl.mainDashboard.hideMemoPack=Este conjunto será removido do Painel de Aprendizado de Longo Prazo. Para adicioná-lo novamente, você precisará clicar em "Começar a aprender" na página do conjunto.
##
packEditor.form.termLanguage=Termo de linguagem
packEditor.form.termLanguage.placeholder=Escolha o idioma
packEditor.form.definitionLanguage=Definição de linguagem
packEditor.form.definitionLanguage.placeholder=Escolha o idioma
packEditor.form.loading=Carregando lista de cartões...
packEditor.form.cardMinimum=Por favor, preencha pelo menos dois flashcards
packEditor.importer.open=Importe de txt, Word, Excel, Google Docs, etc.
packEditor.importer.close=Fechar
packEditor.importer.import=Importar
packEditor.importer.textLabel=Copie e cole o texto aqui (do Word, Excel, Google Docs, etc.)
packEditor.importer.textPlaceholder=Palavra 1    Definição 1\nPalavra 2    Definição 2\nPalavra 3    Definição 3
packEditor.importer.result={0} entradas foram importadas
packEditor.importer.preview.title=Prévia dos cartões
packEditor.importer.preview.empty=Nenhum cartão foi reconhecido. Verifique as configurações de importação no painel direito.
packEditor.anki.button=Importar Anki
packEditor.anki.dialog.message=Carregue seu arquivo .APKG para importar seu baralho de flashcards ANKI.
packEditor.anki.dialog.notice1=Alguns decks não podem ser importados ou podem apresentar erros. Depende da estrutura do deck. Lamentamos o ocorrido.
packEditor.anki.dialog.notice2=Você pode importar seus próprios decks ou decks que você tenha o direito de copiar e modificar.
packEditor.anki.dialog.title=Importar flashcards Anki
packEditor.anki.dialog.button=Navegar
packEditor.anki.progress.sending=Enviando arquivo...
packEditor.anki.progress.parsing=Analisando arquivo...
packEditor.anki.progress.forming=Inserindo resultado no formulário...
packEditor.anki.progress.error=Falha na importação.
packEditor.anki.progress.success=Operação concluída. Novos cartões foram adicionados à lista abaixo.
packEditor.addRow=Adicionar cartão
packEditor.card.term.placeholder=Prazo
packEditor.card.term.needText=Precisa de texto aqui
packEditor.card.def.placeholder=Definição
packEditor.card.def.needText=Precisa de texto aqui
packEditor.importer.form.mode=Modo de importação
packEditor.importer.form.mode.everyLine=O termo e a definição estão em cada linha, separados por delimitador
packEditor.importer.form.mode.lineByLine=O termo e a definição são sequenciais, um elemento por linha
packEditor.importer.form.everyLine1=Delimitador de entrada (linha)
packEditor.importer.form.everyLine2=Delimitador de termo/definição
packEditor.importer.form.everyLine3=Opções adicionais
packEditor.importer.form.ldLine=Quebra de linha
packEditor.importer.form.ldDoubleLine=Quebra de linha dupla
packEditor.importer.form.ldCustom=Símbolo personalizado
packEditor.importer.form.ldJoinLowercase=Junte a linha que começa com o símbolo minúsculo
packEditor.importer.form.tdDash=Traço (-)
packEditor.importer.form.tdTab=Aba
packEditor.importer.form.tdCustom=Símbolo personalizado
packEditor.importer.form.lineByLine1=Opções adicionais
packEditor.importer.form.llDoubleLine=Quebra de linha dupla entre cada grupo
packEditor.importer.form.llJoinLowercase=Junte a linha que começa com o símbolo minúsculo
packEditor.splitNewCards.notice=Parece que você tem muitas cartas. Talvez seja razoável dividir as cartas em vários conjuntos
packEditor.splitNewCards.checkbox.1=Sim, divida as cartas em
packEditor.splitNewCards.checkbox.2=peças em cada conjunto
packEditor.splitNewCards.shuffle=E embaralhe as cartas antes de dividir
packEditor.splitNewCards.suffix=Parte {0}.
packEditor.putToCollection=Adicionar pacote a
packEditor.putToCollection.none=<nenhum>
packEditor.putToCollection.createNew=coleção ou {0}criar nova{1}.
packEditor.images.search=Pesquisar imagens
packEditor.images.search.or=ou
packEditor.images.upload=Carregar
packEditor.images.remove=Remover imagem
packEditor.images.emptySearch=Nenhuma imagem encontrada. Tente outra consulta.
packEditor.audio.record=Registro
packEditor.audio.remove=Remover
packEditor.audio.upload=Carregar
##
collectionForm.modal.title=Criar nova coleção
collectionForm.name=Nome
collectionForm.name.placeholder=Nome da coleção de tipos
collectionForm.description=Descrição
collectionForm.description.placeholder=Descrição da coleção de tipos
##
myPage.title.author=Meus próprios conjuntos
myPage.title.lastPacks=Meus últimos sets
myPage.title.favourite=Meus conjuntos favoritos
myPage.empty.last=Você não visitou nenhum conjunto
myPage.empty.author=Você não criou nenhum conjunto
myPage.empty.favourite=Sua lista de favoritos está vazia
##
packPage.header.from=por
packPage.buttonGroup.play=Jogar
packPage.button.play=Visualização
packPage.button.test=Teste
packPage.button.learn=Aprender
packPage.button.write=Escrever
packPage.button.spell=Soletrar
packPage.button.match=Corresponder
packPage.button.live=Ao vivo
packPage.solw.short=Aprendizagem rápida
packPage.solw.short.subtitle=Repita este conjunto de flashcards
packPage.solw.short.new=Novo:
packPage.solw.short.familiar=Familiar:
packPage.solw.short.mastered=Dominado:
packPage.solw.long=Aprendizagem de longo prazo
packPage.solw.long.subtitle=Repetição espaçada
packPage.solw.long.today=Tarefa de hoje
packPage.solw.long.new=Novo:
packPage.solw.long.review=Para revisar:
packPage.button.memo=Memorando
ppp0.title=Quer aprender esse conjunto rapidamente?
packPage.dialogs.forbidden.alert=Disponível apenas para usuários autorizados
packPage.dialogs.forbidden.addToCollection.text=Você pode adicionar este conjunto a uma de suas coleções
packPage.dialogs.forbidden.addToCollection.alert=Disponível apenas para usuários autorizados
packPage.dialogs.forbidden.createNew.title=Bem-vindo!
packPage.dialogs.forbidden.createNew.text=Somente usuários autorizados podem criar novos cartões.
packPage.dialogs.forbidden.clone.text=Se você usar esses cartões para estudar, mas quiser complementá-los, basta cloná-los e criar um novo conjunto conforme necessário.
packPage.dialogs.forbidden.clone.alert=Disponível apenas para usuários autorizados
packPage.dialogs.addToCollection.title=Adicionar este conjunto à coleção
packPage.dialogs.addToCollection.notice=Você pode adicionar este conjunto de flashcards às suas coleções de estudo
packPage.dialogs.addToCollection.createNew=+ Adicionar nova coleção
packPage.dialogs.addToCollection.forbidden=Somente usuários autorizados podem adicionar cartões aos seus cursos
packPage.dialogs.addToFavourites.title=Adicionar este conjunto aos salvos
packPage.dialogs.addToFavourites.forbidden=Você pode salvar este conjunto para retornar mais tarde
packPage.dialogs.login=Entrar / registrar
packPage.dialogs.share.title=Compartilhe este conjunto
packPage.dialogs.clone.title=Clonar este conjunto
packPage.dialogs.clone.notice=Se você usar esses cartões para estudar, mas quiser complementá-los, basta cloná-los e criar um novo conjunto conforme necessário.
packPage.command.edit=Editar
packPage.command.customize=Personalizar
packPage.command.addTo=Adicionar à ...
packPage.command.addTo.collection=coleção
packPage.command.addTo.saved=salvo
packPage.command.share=Compartilhar
packPage.list.sorting.original=Original
packPage.list.sorting.alphabetical=Alfabético
packPage.list.filter.all=Mostrar tudo
packPage.list.filter.difficult=Difícil
packPage.list.filter.banned=Ignorado
packPage.list.filter.mastered=Dominado
packPage.list.filter.familiar=Familiar
packPage.list.filter.starred=Estrelou
packPage.list.emptyMessage=Nenhum cartão se encaixa neste filtro
packPage.list.loadMore=Ver mais cartões
packPage.review=Análise
packPage.startMemo=Adicionar ao balcão de aprendizagem de longo prazo
packPage.startLearning=Comece a aprender
packPage.speedReview=Revisão de velocidade
packEmbed.clickToFlip=Clique para inverter
packPage.tooltips.memoShort=O modo de aprendizagem rápida é útil quando você precisa repetir algumas palavras ou questões antes da prova. Adequado para pequenos conjuntos de palavras.
packPage.tooltips.memoLong=O modo de aprendizagem por repetição espaçada baseia-se no método de repetição intervalada. É útil para a preparação sistemática de exames e para a educação a longo prazo.
packPage.tooltips.preview=Veja todos os conjuntos de cartas sem se controlar.
packPage.tooltips.test=Crie um teste para verificar seus conhecimentos em um conjunto de cartas.
packPage.tooltips.spell=Corretor ortográfico. Teste de audição e escrita.
##
packPlay.back=Voltar
packPlay.options=Opções
packPlay.progress=Progresso
packPlay.progressTemplate={0} de {1}
packPlay.wrongDisplay.title=Resposta errada
packPlay.wrongDisplay.label=Resposta correta
packPlay.wrongDisplay.continueText=Pressione qualquer tecla para continuar
packPlay.wrongDisplay.userLabel=Você escreveu
packPlay.wrongDisplay.typeText=Digite a resposta correta abaixo
##
packLearn.remaining=Restante
packLearn.familiar=Familiar
packLearn.mastered=Dominado
packLearn.write.placeholder=escreva sua resposta aqui
packLearn.write.placeholderCopy=copie a resposta correta aqui
packLearn.write.submit=Responder
packLearn.write.skip=Pular
packLearn.write.stillCorrect=Eu estava certo
packLearn.write.giveup=Desistir
packLearn.dialogs.options.title=Opções
packLearn.dialogs.options.questionTitle=Responder com
packLearn.dialogs.options.questionTerm=Prazo
packLearn.dialogs.options.questionDefinition=Definição
packLearn.dialogs.options.questionError=Pelo menos uma caixa de seleção deve ser marcada
packLearn.dialogs.options.modeTitle=Tipos de perguntas
packLearn.dialogs.options.modeSelect=Múltipla escolha
packLearn.dialogs.options.modeWrite=Escrito
packLearn.dialogs.options.modeError=Pelo menos uma caixa de seleção deve ser marcada
packLearn.dialogs.options.modeRandom=Ordem aleatória
packLearn.dialogs.options.resetTitle=Reiniciar o progresso
packLearn.dialogs.options.resetButton=Reiniciar
packLearn.dialogs.options.modeCards=Flashcards
packLearn.dialogs.config.title=Opções de memorando
packLearn.dialogs.firstTime.title=Configuração pela primeira vez
packLearn.dialogs.firstTime.notice=Você pode alterar essas configurações no menu "Opções" a qualquer momento
packLearn.dialogs.options.writeAnyAnswer=Escreva qualquer resposta
packLearn.dialogs.options.writeAnyAnswer.notice=Você pode escrever apenas uma das respostas disponíveis (que são separadas por vírgula).
packLearn.dialogs.options.playAudio=Reproduzir áudio
packLearn.dialogs.options.newLimit=Novo limite de cartões
packLearn.dialogs.options.newLimitError=Deve ser um número positivo, menor ou igual a 50
packLearn.dialogs.options.order=Ordem de novo
packLearn.dialogs.options.order.original=Original
packLearn.dialogs.options.order.random=Aleatório
packLearn.dialogs.options.advancedMode=Modo avançado
packLearn.dialogs.options.advancedMode.notice=Por padrão, o "aprendizado de longo prazo" usa um algoritmo de repetição espaçada de aprendizado modificado, no qual basta escolher apenas "Sei" ou "Não sei". Ao alternar para o "Modo avançado", você pode usar um algoritmo clássico com cinco opções disponíveis, semelhante ao Supermemo ou Anki.
##
searchPage.title=Pesquisar "{0}"
searchPage.head=Resultados para a consulta "{0}"
searchPage.display.packs=Mostrar conjuntos
searchPage.display.courses=Mostrar cursos
searchPage.noResults.packs=Desculpe, nenhum conjunto foi encontrado
searchPage.noResults.courses=Desculpe, nenhum curso foi encontrado
##
learnPage.progress.total=Aprovado
learnPage.progress.correct=Correto
learnPage.progress.wrong=Errado
learnPage.answer.go=Responder
learnPage.answer.placeholder=Digite sua resposta
learnPage.answer.unknown=Não sei
learnPage.wrong.stillCorrect=Minha resposta está correta!
learnPage.next=Próximo
learnPage.result.actual=Sua Resposta
learnPage.result.correct=Resposta correta
learnPage.header.correct=Resposta correta
learnPage.header.wrong=Resposta errada
learnPage.emptyQueue=Parabéns! Você passou em todas as cartas.
learnPage.restartQueue=Reiniciar
learnPage.reviewComplete.title=Parabéns!
learnPage.reviewComplete.text=Você passou todas as cartas.
##
testSelectPage.opt.limit=Limite de perguntas
testSelectPage.opt.first=Mostrar
testSelectPage.start=Iniciar teste
testSelectPage.opt.limit.prefix=Usar
testSelectPage.opt.limit.suffix=de {0}
testSelectPage.opt.first.face=Prazo
testSelectPage.opt.first.back=Definição
testSelectPage.mode1=Corresponder
testSelectPage.mode2=Sim / Não
testSelectPage.mode3=4 opções
testSelectPage.mode4=Escrever
##
testResult.message=Sua pontuação:
testResult.correctTitle=Resposta esperada
testResult.noAnswer=Você não seleciona nada
testResult.noAnswerWrite=Você não escreve nada
testCheck.answer=Responder:
testCheck.answer.yes=Correto
testCheck.answer.no=Errado
testCheck.answer.correct=Correto!
testCheck.answer.wrong=Errado!
testWrite.input.placeholder=Digite sua resposta aqui
##
uknownPack.text=Talvez já tivéssemos esse conjunto antes... Infelizmente, ele não está mais disponível :(
packOnVerification.text=Este pacote estará disponível ao público após verificação. Aguarde.
##
packTest.form.questionLimit=Limite de perguntas
packTest.form.questionLimit.of=de
packTest.form.questionLimit.invalid=A contagem de perguntas é inválida.
packTest.form.questionWith=Pergunta com
packTest.form.questionWith.notSelected=Pelo menos uma opção é necessária.
packTest.form.requireOne=Exigir apenas uma resposta
packTest.form.requireOne.explain=É necessária pelo menos uma resposta correta. As respostas devem ser separadas por uma barra (/), uma vírgula (,) ou um ponto e vírgula (;).
packTest.form.types=Tipos de perguntas
packTest.form.types.notSelected=Pelo menos uma opção é necessária.
packTest.form.type.choice=Múltipla escolha
packTest.form.type.yn=Verdadeiro/Falso
packTest.form.type.written=Escrito
packTest.form.type.matching=Correspondência
packTest.start=Iniciar teste
packTest.qsMatching=Perguntas para correspondência
packTest.qsMatching.expected=A resposta correta é:
packTest.qsWritten=Perguntas para escrever
packTest.qsWritten.inputPlaceholder=digite sua resposta aqui
packTest.qsWritten.expected=A resposta correta é:
packTest.qsChoice=Perguntas para escolha
packTest.qsChoice.expected=A resposta correta é:
packTest.qsYN=Perguntas para verdadeiro/falso
packTest.qsYN.true=Verdadeiro
packTest.qsYN.false=Falso
packTest.qsYN.expected=A resposta correta é:
packTest.checkAnswers=Verifique as respostas
packTest.score.prefix=Resultado do teste:
packTest.score.90=Excelente!
packTest.score.75=Bom!
packTest.score.50=Média
packTest.score.25=Pobre
packTest.score.0=Fraco
##
columns.cardsInPack=Cartões
##
fexplorer.page.title={0} explorador de flashcards
fexplorer.page.categoryTitle={0} Flashcards
fexplorer.title=Explorador de flashcards
fexplorer.popularsCategories=Categorias populares
fexplorer.language=Minha língua
fexplorer.allCategories=Todas as categorias
fexplorer.collections.section=Coleções
fexplorer.flashcards.section=Flashcards
fexplorer.flashcards.terms=termos
fexplorer.empty.message=Selecione uma categoria <br>ou<br>
fexplorer.empty.search=Pesquisar algo
##
packPlay.progressBar.title=Progresso
packPlay.head.play=Flashcards
packPlay.head.learn=Aprender
packPlay.head.review=Análise
packPlay.head.test=Teste
packPlay.head.write=Escrever
packPlay.head.memo=Memorando
packPlay.head.spell=Soletrar
packPlay.head.match=Corresponder
##
packMemo.showAnswer=Mostrar resposta
packMemo.sessionComplete=Não mais cartões<br>por hoje!
packMemo.sessionNextTime=Volte em {0}.
packMemo.grades.button.H=Dificilmente
packMemo.grades.button.E=Fácil
packMemo.grades.button.M=Médio
packMemo.grades.button.1=Ruim
packMemo.grades.button.2=Fraco
packMemo.grades.button.3=Médio
packMemo.grades.button.4=Bom
packMemo.grades.button.5=Forte
packMemo.grades.button.Y=Ok, eu lembro
packMemo.grades.button.R=Eu sei
packMemo.grades.button.F=Não sei
packMemo.short.days=d
packMemo.short.months=me
packMemo.short.hours=h
packMemo.welcome.title=Mesa de Aprendizagem de Longo Prazo
packMemo.welcome.text=É um programador de repetição espaçada. Assim que você iniciar o processo de aprendizagem, aprenderá 20 cartas por dia. A frequência com que as cartas são mostradas depende das suas respostas. Este modo é baseado no famoso algoritmo de repetição espaçada chamado SM-2. <br><a href="https://en.wikipedia.org/wiki/SuperMemo">Saiba mais.</a>
packMemo.welcome.start=Vamos começar
packMemo.welcome.login=Infelizmente, este modo está disponível apenas para usuários autorizados.<br>Por favor, <a href="/login">faça login</a> ou <a href="/registration">inscreva-se</a>. <br>É fácil e totalmente gratuito.




packMemo.help.title=Dica
packMemo.help.line1=Barra de espaço para mostrar a resposta
packMemo.help.line2=1,2,3,4,5 para fazer sua escolha
packMemo.help.hide=Esconder
packMemo.end.freshAvailable=Você quer ver mais cartões novos hoje?
packMemo.end.freshAccept=Sim, mostre-me mais
##
fl.matchGame.welcome.text=Arraste os itens uns sobre os outros para fazê-los desaparecer
fl.matchGame.startGame=Iniciar jogo
fl.matchGame.timer=Tempo
fl.matchGame.preset.number=Contar
fl.matchGame.result.title=Parabéns!
fl.matchGame.result.text=Sua pontuação é de {0} segundos
fl.matchGame.result.again=Jogar novamente
##
fl.memoHeatMap.title=Seu histórico de aprendizagem
fl.memoHeatMap.legend.daverage=Média diária:
fl.memoHeatMap.legend.daverage.value={0} {0,plural,one{cartão}few{cartas}other{cartas}}
fl.memoHeatMap.legend.dlearned=Dias aprendidos:

fl.memoHeatMap.legend.beststreak=Melhor sequência:
fl.memoHeatMap.legend.beststreak.value={0} {0,plural,one{dia}few{dias}other{dias}}
fl.memoHeatMap.legend.currentstreak=Sequência atual:
fl.memoHeatMap.legend.currentstreak.value={0} {0,plural,one{dia}few{dias}other{dias}}
fl.memoHeatMap.tooltip.passed={0} {0,plural,one{passou na revisão}few{avaliações aprovadas}other{avaliações aprovadas}}
fl.memoHeatMap.tooltip.failed={0} {0,plural,one{revisão falhada}few{avaliações reprovadas}other{avaliações reprovadas}}
fl.memoHeatMap.tooltip.fresh={0} {0,plural,one{cartão novo}few{cartas novas}other{cartas novas}}
fl.memoHeatMap.tooltip.date=em {0}
##
cardButtons.ban.title=Banir este cartão
cardButtons.edit.title=Corrija este cartão
cardButtons.star.title=Alternar cartão favorito
cardButtons.ban.prompt=Ignorar este cartão?
##
validation.cardText.tooLong=O comprimento máximo deste texto é de 1000 caracteres
##
extLocale.la=Latim
extLocale.rw=Kinyarwanda
extLocale.af=afrikaans
extLocale.am=Amárico
extLocale.az=azerbaijano
extLocale.bn=Bengal
extLocale.bs=Bósnio
extLocale.ceb=Cebuano
extLocale.co=corso
extLocale.cy=galês
extLocale.eo=esperanto
extLocale.eu=Basco
extLocale.fa=persa
extLocale.fy=Frísio
extLocale.gd=Escocês (gaélico)
extLocale.gl=Galego
extLocale.gu=Gujarati
extLocale.ha=Casa
extLocale.haw=havaiano
extLocale.hmn=Hmong
extLocale.ht=Crioulo (Haiti)
extLocale.hy=armênio
extLocale.id=indonésio
extLocale.ig=Igbo
extLocale.jw=Javanês
extLocale.ka=Georgiano
extLocale.kk=cazaque
extLocale.km=Khmer
extLocale.kn=Kannada
extLocale.ku=Kurmanji
extLocale.ky=Quirguistão
extLocale.lb=Luxemburgo
extLocale.lo=Laosiano
extLocale.mg=malgaxe
extLocale.mi=maori
extLocale.ml=Malaiala
extLocale.mn=mongol
extLocale.mr=Marathi
extLocale.my=birmanês
extLocale.ne=Nepalês
extLocale.ny=Ceva
extLocale.or=Oria
extLocale.pa=Punjabi
extLocale.ps=Pashto
extLocale.sd=Sindi
extLocale.si=cingalês
extLocale.sm=samoano
extLocale.sn=Shona
extLocale.so=Somali
extLocale.st=Sesoto
extLocale.su=sudanês
extLocale.sw=Suaíli
extLocale.ta=tâmil
extLocale.te=télugo
extLocale.tg=Tadjique
extLocale.tk=turcomano
extLocale.tl=filipino
extLocale.tt=tártaro
extLocale.ug=uigur
extLocale.ur=urdu
extLocale.uz=Uzbeque
extLocale.xh=Xhosa
extLocale.yi=iídiche
extLocale.yo=Iorubá
extLocale.zu=zulu


# landing
fl.landing.title=Aprendendo com {0}
fl.landing.title.small=Saiba o que {0} pode agregar ao seu processo de aprendizagem
fl.landing.why1.title=É fácil e divertido
fl.landing.why1.text=Milhares de crianças em idade escolar e estudantes fazem suas tarefas {0} todos os dias, melhorando suas notas. No sofá, no metrô, na fila — sempre sobra um tempinho para estudar.
fl.landing.why2.title=Seis modos de aprendizagem
fl.landing.why2.text=Escolha as ferramentas que melhor se adaptam às informações que você precisa aprender.
fl.landing.why3.title=Repetição espaçada
fl.landing.why3.text=Com base no estudo da psicologia, o método de repetição espaçada permite que você se lembre de grandes quantidades de informação sem esforço extraordinário. Basta praticar por 10 a 15 minutos por dia.
fl.landing.why4.title=Em qualquer dispositivo
fl.landing.why4.text=Trabalhe no dispositivo que você tem em mãos. Não importa se é um computador, tablet ou celular — nossas ferramentas são otimizadas para eles.
fl.landing.create.title=Crie seus próprios conjuntos de cartas
fl.landing.create1.title=Criando memorizar
fl.landing.create1.text=Para preparar um conjunto, você precisa estruturar e simplificar as informações. Esta é uma das melhores maneiras de dominar o material. No futuro, você só precisará refrescar a memória.
fl.landing.create2.title=Importação conveniente
fl.landing.create2.text=Use a ferramenta flexível de importação de arquivos de texto para carregar conjuntos de outras fontes. Você também pode importar um arquivo ANKI.
fl.landing.create3.title=Modificar
fl.landing.create3.text=Escolha um conjunto adequado em nosso banco de dados, altere e complemente de acordo com seu currículo.
fl.landing.create.button=Criar um conjunto
fl.landing.gallery=Exemplos
fl.landing.gallery.others=Veja outros exemplos
fl.landing.stars1=3 milhões de estudantes todos os meses
fl.landing.stars2=Mais de 100.000.000 de sessões de treinamento
fl.landing.stars3=Mais de 1.000.000 kits educacionais
fl.landing.reg1=Cadastre-se agora e use cartões educacionais de treinamento intervalado, coleções educacionais e documentos educacionais úteis.
fl.landing.reg2=Não tem conta no Google ou no Facebook? Sem problemas! Cadastre-se com seu e-mail.
## fast add card










## uninstall page
fl_uninstall_title=Obrigado por usar a extensão Studylib.
fl_uninstall_subtitle=Lamentamos sua partida! Se tiver um tempinho, diga-nos como podemos melhorar a Extensão:
fl_uninstall_notice=Seu feedback nos ajuda a melhorar o produto para todos, obrigado 😊
fl_uninstall_button=Enviar
fl_uninstall_success=Vejo você em breve!

## APPEND ITEMS ABOVE THIS LINE